export default "__VITE_ASSET__Drs$iZCZ__"